<template>
  <section id="admin-dashboard">
    <div class="flex flex-col justify-center align-center px-10">
      <div class="flex flex-col text-left w-full mt-5 mb-5">
        <h1 class="big-title mb-0">Espace admin</h1>
        <p class="subtitle">Un aperçu des données de l'application</p>
      </div>
    </div>

    <div class="white-rectangle p-8">
      <h2 class="mb-1">Statistiques globales</h2>
      <div class="flex">
        <div class="project-card mr-5" :class="[`bg-red`]">
          <div class="project-card-content flex items-center justify-center">
            <div class="bg-white p-3 rounded-full">
              <v-mdi
                class="icon-red"
                size="40"
                name="mdi-account-outline"
              ></v-mdi>
            </div>
            <div class="relative text-white px-6 py-6">
              <span class="mt-0 text-2xl"><b>{{stats.nbUserTotal}}</b><br /></span>
              <span class="mb-2 mt-0 text-xl">utilisateurs</span>
            </div>
          </div>
        </div>

        <div class="project-card mr-5 relative" :class="[`bg-blue`]">
          <div class="project-card-content flex items-center justify-center">
            <div class="bg-white p-3 rounded-full">
              <v-mdi
                class="icon-blue"
                size="40"
                name="mdi-cube-outline"
              ></v-mdi>
            </div>
            <div class="relative text-white px-6 py-6">
              <span class="mb-2 mt-0 text-2xl"><b>{{stats.nbProjetTotal}}</b><br /></span>
              <span class="mb-2 mt-0 text-xl">projets</span>
            </div>
          </div>
        </div>

        <div>
          <p>En moyenne, chaque utilisateur crée <b>{{stats.nbProjetMoyenneParUtilisateur}} projets</b>.</p>
          <br />
          <p>En moyenne, chaque projet est composé de <b>{{stats.nbUtilisateursMoyenneParProjet}} utilisateurs</b>.</p>
        </div>
      </div>
    </div>

    <div class="white-rectangle p-8 mt-5 flex">
      <div class="col mr-5">
        <h2 class="mb-3">Répartition des projets</h2>
        <div class="flex">
          <div class="col flex flex-col justify-center w-1/3">
            <span>Sur <b>{{stats.nbProjetTotal}}</b> projets, il y a
            <b>{{stats.nbProjetEquipe}} projets individuels</b> ou d’équipe,
            <b>{{stats.nbProjetEnseignant}} projets d’enseignement</b> ainsi que <b>{{stats.nbProjetExamen}} projets d'examen</b>.</span>
            <router-link
              :to="{ name: 'Admin Projects' }">
            <div class="button">
              <Button
                class="mt-5 bg-validate btn-green"
                icon="mdi-format-list-bulleted"
                :icon-size="20"
                label="Gérer les projets"
              />
            </div>
            </router-link>
          </div>
          <div class="col w-2/3 flex">
            <div class="flex items-center justify-center mr-5 pointer-events-none">
              <div class="absolute mt-2 bg-white p-5 rounded-full">
                <v-mdi
                class="p-2"
                size="75"
                name="mdi-cube-outline"
                ></v-mdi>
                </div>
              <pie-chart v-if="pieChart.loaded" :width="200" :height="200" :data="pieChart.chartData" :options="pieChart.options"></pie-chart>
            </div>
            <div class="flex flex-col justify-center">
              <div class="flex items-center mb-5">
                <div class="w-20 h-6 rounded-lg bg-green mr-2"></div>
                <span class="text-xl">Équipe</span>
              </div>
              <div class="flex items-center mb-5">
                <div class="w-20 h-6 rounded-lg bg-blue mr-2"></div>
                <span class="text-xl">Enseignement</span>
              </div>
              <div class="flex items-center">
                <div class="w-20 h-6 rounded-lg bg-red mr-2"></div>
                <span class="text-xl">Examens</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col ml-9.5">
        <div class="flex items-center mt-3 mb-5">
          <div class="w-24 h-1 bg-primary mr-2"></div>
          <span>Nombre de projets ouverts</span>
        </div>
        <line-chart v-if="projectsLineChart.loaded" :height="200" :chart-data="projectsLineChart.chartData" :options="projectsLineChart.options"></line-chart>
      </div>
    </div>

    <div class="white-rectangle p-8 mt-5">
        <h2 class="mb-3">Utilisateurs du site</h2>
        <div class="flex">
          <div class="col flex flex-col justify-center">
            <div class="flex items-center mb-5">
              <div class="w-10 h-1 bg-green mr-2"></div>
              <span class="text-xl">Nombre d'utilisateurs inscrits par mois</span>
            </div>
            <div class="text-xl">Par jour, nous avons en moyenne <b>{{stats.nbUtilisateurEnregistresParJour}} nouveaux utilisateurs</b> incrits.</div>
          </div>
          <div class="col">
            <div class="ml-8">
              <line-chart v-if="usersLineChart.loaded" :height="200" :chart-data="usersLineChart.chartData" :options="usersLineChart.options"></line-chart>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import PieChart from "./graph/PieChart.js";
import LineChart from "./graph/LineChart.js";
import { mapActions, mapGetters } from 'vuex';

export default {
  name:"Dashboard",
  extends: PieChart,
  components: {
    LineChart, PieChart
  },
  data() {
    return {

      pieChart: {
        loaded: false,
        chartData: {
          datasets: [
            {
              borderWidth: 0,
              label: "Data One",
              backgroundColor: ["#56CCF2", "#64D87E", "#DC582A"],
              data: [10, 2, 3]
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true
        },
      },

      projectsLineChart: {
        loaded: false,
        chartData: {
          labels: ["22 mars", "23 mars", "24 mars", "25 mars", "26 mars", "27 mars", "28 mars", "29 mars", "30 mars", "31 mars"],
            datasets: [
              {
                data: [70, 10, 60, 30, 50, 90, 70, 60, 50, 50],
                label: "Nombre de projets ouverts",
                borderColor: "#56CCF2",
                fill: false
              }
            ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: false
          }
        }
      },

      usersLineChart: {
        loaded: false,
        chartData: {
          labels: ["6.00", "7.00", "8.00", "9.00", "10.00", "11.00", "12.00", "13.00", "14.00", "15.00"],
            datasets: [
              {
                data: [600, 550, 600, 700, 1000, 950, 1050, 700, 600, 500],
                label: "Nombre d'utilisateurs inscrits par jour",
                borderColor: "#64D87E",
                fill: false
              },
            ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: false
          }
        },
      },
    };
  },
  async mounted() {
    await this.fetchStats();
    
    if(this.stats) {
      this.pieChart.chartData.datasets[0].data = [this.stats.nbProjetEnseignant, this.stats.nbProjetEquipe, this.stats.nbProjetExamen];
      this.pieChart.loaded = true;

      let projectsLineChartLabels = this.stats.nbProjetOuvertParMois;
      projectsLineChartLabels = Object.keys(projectsLineChartLabels)
      this.projectsLineChart.chartData.labels = projectsLineChartLabels;

      let projectsLineChartValues = this.stats.nbProjetOuvertParMois;
      projectsLineChartValues = Object.values(projectsLineChartValues)
      this.projectsLineChart.chartData.datasets[0].data = projectsLineChartValues;
      this.projectsLineChart.loaded = true;

      let usersLineChartLabels = this.stats.nbUtilisateurInscritParJour;
      usersLineChartLabels = Object.keys(usersLineChartLabels)
      this.usersLineChart.chartData.labels = usersLineChartLabels;

      let usersLineChartValues = this.stats.nbUtilisateurInscritParJour;
      usersLineChartValues = Object.values(usersLineChartValues)
      this.usersLineChart.chartData.datasets[0].data = usersLineChartValues;
      this.usersLineChart.loaded = true;
    }
  },
  computed: {
    ...mapGetters({
      stats: 'admin/getStats'
    })
  },
    methods: {
      ...mapActions({
      fetchStats: 'admin/fetchStats'
    }),
  },
}

</script>

<style scoped>
.icon-red {
  fill: #cd3b18;
}

.icon-blue {
  fill: #41b6e6;
}

.project-card {
  min-height: 0;
}
</style>
